import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Transition } from "../../pages/app/utils/animation";
import { Warning } from "@mui/icons-material";
import { useModals } from "../../store/dialogs/hooks.js";
import { ASI, NLMS } from "../../pages/app/utils/constants.js";

export const SingleChannelActiveDialog = ({ filterName }) => {
  const {
    showSingleChannelActiveDialog,
    closeSingleChannelActiveDialog,
    openASIFilterDialog,
    openNLMSFilterDialog,
  } = useModals();
  return (
    <Dialog
      aria-labelledby="single-channel-active-dialog"
      aria-describedby="single-channel-active-dialog-description"
      aria-hidden={!showSingleChannelActiveDialog}
      closeAfterTransition={false}
      onClose={() => closeSingleChannelActiveDialog()}
      open={showSingleChannelActiveDialog}
      maxWidth="xs"
      slots={{
        transition: Transition,
      }}
      keepMounted
    >
      <DialogTitle
        id="single-channel-active-dialog-title"
        display="flex"
        alignItems="center"
        gap={0.5}
      >
        <Warning color="warning" fontSize="medium" />
        Warning
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="single-channel-active-dialog-description">
          There is only one active channel for this clip. Running the{" "}
          {filterName} filter will impact your ability to run GLIMPSE.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => closeSingleChannelActiveDialog()}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            closeSingleChannelActiveDialog();
            if (filterName === ASI) {
              openASIFilterDialog();
            } else if (filterName === NLMS) {
              openNLMSFilterDialog();
            }
          }}
          autoFocus
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
